//对接后台错误码

var errorType = {};

const errMsg = {
  text:{
    pleaseSelectAStoragePeriod:"Please select a storage period",//请选择存储期限
    currentlySelectedStorage:"The currently selected storage period is less than the originally selected period！",//当前所选存储期限小于原选期限

  },
  //数据字典类型
  dict: {},
  //批量导入后台返回
  0x00000: {
    message: "Account {account} already exists"
  },
  0x00001: {
    message: "Account {account}，Please re-check if the group is correct ！"
  },
  0x00005:{
    message:'Duplicate account !',
  },
  0x00104:{
    message:'Parameter error.',
  },
  common: {
    0x00002: {
      message: "Account or password error!"
    },
    0x00003: {
      message: "Account is disable"
    },
    0x00004: {
      message: "Account or password error!!! "
    },
    100043:{
      message: "The number of users in the group exceeds the limit!s"//群组中用户数量超出规定!
    },
    100044:{
      message: "The user does not have permission!"//用户没有设置权限
    },
    100045:{
      message: "The scheduling function is not configured for the account!"//账号没有设置调度功能
    },
    100046:{
      message: "User has no feature!"//用户没有功能项!
    },
    //qb相关的异常信息
  },
  0x00014: {
    message: "Target operational QB deficiency !"
  },
  0x00015: {
    message: "Terminal QB upper limit !"
  },
  0x00016: {
    message:"Target is activated, not recyclable"
  },
  100001: {
    message: "Iccid is empty"//iccid为空
  },
  100002: {
    message: "Not an iccid in the system"//不属于系统中的iccid
  },
  100003: {
    message: "There are already bound enterprises in iccid data"//数据中有iccid已经绑定企业
  },
  100004: {
    message: "The bound enterprise id already exists in the data generated between this zone"//该区间生成的数据中已有绑定企业id
  },
  100005: {
    message: "Iccid already exists"//iccid已经存在
  },
  100006: {
    message: "There were iccid duplicates in the interval data"//区间数据中有iccid重复
  },
  100007: {
    message: "There were iccid duplicates in batch additions"//批量新增的数据中有iccid重复
  },
  100008: {
    message: "Unbundling failure"//解绑失败
  },
  100009: {
    message: "The iccid does not belong to any business"//该iccid不属于任何企业
  },
  100010: {
    message: "The iccid is not owned by the company"//该iccid不属于这个企业
  },
  100011: {
    message: "The iccid has already bound the user"//该iccid已经绑定了用户
  },
  100012: {
    message: "Internet of things card number is empty"//物联网卡号为空
  },
  100013: {
    message: "This iccid has no bound user"//该iccid没有绑定用户
  },
  100014: {
    message: "The last four digits can only be Numbers"//后4位只能是数字
  },
  100015: {
    message: "You can only create 100 users at a time"//一次最多只能创建50个用户
  },
  100016: {
    message: "Data does not meet format requirements"//数据不满足格式要求
  },
  100017: {
    message: "Enterprises are short of q-coins"//企业Q币数量不足
  },
  100018: {
    message: "The length of iccid can only be 20"//iccid的长度只能是20位
  },
  100019: {
    message: "The iccid common parts are different"//iccid的公共部分不相同
  },
  100020: {
    message: "The last four digits can only be Numbers"//后4位只能是数字
  },
  100021: {
    message: "The number at the end of the run cannot be smaller than the number at the beginning"//末数字要比开始数字大
  },
  100022: {
    message: "The enterprise id cannot be empty"//企业id不能为空
  },
  100023: {
    message: "This is not a business"//这不是企业
  },
  100024: {
    message: "No IMEI creation or iccid serial creation was performed "//没有执行IMEI创建或iccid串行创建    iccid或者文本框中没有数据
  },
  100025: {
    message: "data："//数据
  },
  100026: {
    message: "The length does not meet the requirements"//长度不符合条件
  },
  100027: {
    message: "Does not meet the format requirements"//Does not meet the format requirements
  },
  100028: {
    message: "Password："//密码
  },
  100029: {
    message: "6-15 letters or Numbers are not acceptable"//不符合6-15 字母或者数字的要求
  },
  100030: {
    message: "Group Name："//组名
  },
  100031: {
    message: "Only 2-10 characters"//只能是2-10字符
  },
  100032: {
    message: "Repetition"//重复
  },
  100033: {
    message: "Account："//账号
  },
  100034: {
    message: "6-15 letters or Numbers are not acceptable"//不符合6-15 字母或者数字的要求
  },
  100035: {
    message: "To generate an account:"//要生成账号
  },
  100036: {
    message: "A maximum of 100 can be added at a time"//一次最多只能新增50个
  },
  100037:{
    message: "Update failed"//更新失败
  },
  100038:{
    message: "Iccid Wrong number or nonexistent"//iccid号码错误或者不存在
  },
  100039:{
    message: "In use! A secondary activation operation cannot be performed"//在用状态!不能进行二次激活操作
  },
  100040:{
    message: "The number is being processed, please send it later"//该号码已有业务正在处理，请稍后下发
  },
  100041:{
    message: "The query fails"//查询失败
  },
  100042:{
    message: "The number of users in the group exceeds the limit!s"//群组中用户数量超出规定!
  },
  100043:{
    message: "The number of users in the group exceeds the limit!s"//群组中用户数量超出规定!
  },

  100050:{
    message: "The order number does not exist" //该订单号不存在
  },

  500:{
    message: "Server internal error!"//服务器内部错误
  },

};

export default errMsg;



// WEBPACK FOOTER //
// ./src/api/lang/modules/error/errMsg_en.js